import { ItemGrid } from './components/ItemsGrid/ItemsGrid';
import Header from './components/Header/Header';

const App = () => {
  return (
    <>
      <Header></Header>
      <ItemGrid></ItemGrid>
    </>
  );
};

export default App;
